<template>
  <b-modal id="modal-bundle" modal-class="bundle-modal" ok-only ok-title="Accept" centered size="lg"
    title="Tambah Bundle" @hide="handleHideModal" no-close-on-backdrop>
    <div class="section">
      <b-container class="">
        <b-row>
          <!-- Name Bundle -->
          <b-col cols="12" md="12" class="custom__form--input mb-2">
            <label for="v-nama-barang">Nama Bundle <span class="text-danger">*</span></label>
            <b-form-group>
              <b-form-input id="v-nama-barang" v-model="formPayload.name" type="text" placeholder="Nama Kategori"
                class="custom__input" />
            </b-form-group>
          </b-col>
          <!-- Image -->
          <b-col cols="12" md="12" class="custom__form--input mb-2">
            <label for="v-image">Gambar (opsional)</label>
            <b-form-group>
              <b-form-file v-model="formPayload.image" placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..." class="" />
            </b-form-group>
          </b-col>
          <!-- No Period -->
          <b-col cols="12" md="12" class="custom__form--input mb-2">
            <label for="v-total-price">No Period</label>
            <b-form-group>
              <b-form-checkbox v-model="formPayload.is_no_period"></b-form-checkbox>
            </b-form-group>
          </b-col>
          <!-- Date From -->
          <b-col cols="12" md="12" class="custom__form--input mb-2">
            <label for="v-date-from">Berlaku dari</label>
            <b-form-group>
              <b-form-datepicker id="v-date-from" v-model="formPayload.start_date" class="custom__input"
                :disabled="formPayload.is_no_period" />
            </b-form-group>
          </b-col>
          <!-- Date End -->
          <b-col cols="12" md="12" class="custom__form--input mb-2">
            <label for="v-date-end">Berlaku Sampai</label>
            <b-form-group>
              <b-form-datepicker id="v-date-end" v-model="formPayload.end_date" class="custom__input"
                :disabled="formPayload.is_no_period" />
            </b-form-group>
          </b-col>
          <!-- Total Price -->
          <b-col cols="12" md="12" class="custom__form--input mb-2">
            <label for="v-total-price">Total Harga <span class="text-danger">*</span></label>
            <b-form-group>
              <input id="v-total-price" class="focus-0 custom__input pl-1 w-100" type="text" :value="price"
                @input="getPrice" @change="getPrice" placeholder="Total Harga">
            </b-form-group>
          </b-col>

        </b-row>

        <b-row>
          <b-col>
            <h4>Daftar Konten Bundle</h4>
            <b-button class="mb-1" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="repeateAgain">
              <feather-icon icon="PlusIcon" class="mr-25" />
              <span>Tambah produk</span>
            </b-button>
            <b-form ref="form" class="repeater-form" @submit.prevent="repeateAgain">
              <!-- Row Loop -->
              <b-row v-for="(item, index) in formPayload.items" :id="item.id" :key="item.id" ref="row">

                <!-- Item Name -->
                <b-col class="" lg="4">
                  <b-form-group class="custom__form--input mb-0" label-for="item-name">
                    <v-select v-model="formPayload.items[index].product_uuid" label="name" :options="optionsProduct"
                      placeholder="Pilih Produk" @search="onSearchProduct" />
                    <!-- <b-form-input class="custom__input" id="item-name" type="text" placeholder="Produk" /> -->
                  </b-form-group>
                  <p class="text-dark font-weight-bold mb-25" v-if="formPayload.items[index].product_uuid">Harga satuan:
                    <span v-if="formPayload.items[index].product_uuid.standard_price > 0">{{
                      formPayload.items[index].product_uuid.standard_price | formatAmount }}</span>
                    <span v-else>{{ 0 | formatAmount }}</span>
                  </p>
                </b-col>

                <!-- Warehouse -->
                <b-col class="" lg="4">
                  <b-form-group class="custom__form--input mb-0" label-for="cost">
                    <!-- <b-form-select v-model="items[index].warehouse_uuid" :options="optionsWarehouse"
                      placeholder="Pilih Lokasi SKU" /> -->
                    <v-select :open="true" v-model="formPayload.items[index].warehouse_uuid" label="name"
                      :reduce="option => option.uuid"
                      :options="optionsWarehouse[index] ? optionsWarehouse[index].warehouses : []"
                      placeholder="Pilih Lokasi SKU" :disabled="!formPayload.items[index].product_uuid" />
                    <!-- <b-form-input class="custom__input" id="cost" type="number" placeholder="Gudang" /> -->
                  </b-form-group>
                  <p class="text-danger mb-25" v-if="items[index] && items[index].stock == 0">Stock digudang
                    kosong</p>
                </b-col>

                <!-- Stock -->
                <b-col class="" lg="2">
                  <b-form-group class="custom__form--input mb-0">
                    <div id="tour-qty" class="spinner__button spinner__button--addproduct"
                      :class="{ 'disabled': items[index] && !formPayload.items[index].warehouse_uuid && !formPayload.items[index].product_uuid }">
                      <!-- Decrease Button -->
                      <div id="decrease" class="value-button text-dark font-weight-bolder" value="Decrease Value"
                        @click="decreaseQty(index)">
                        -
                      </div>

                      <!-- Editable Input -->
                      <input id="qty" class="qty text-dark font-weight-bolder" type="number"
                        :value="formPayload.items[index].qty" @input="(e) => updateQty(index, e.target.value)"
                        @change="(e) => validateQty(index)" :min="0" />

                      <!-- Increase Button -->
                      <div id="increase" class="value-button text-dark font-weight-bolder" value="Increase Value"
                        @click="increaseQty(index)">
                        +
                      </div>
                    </div>
                  </b-form-group>

                  <!-- Total Price -->
                  <p class="mb-25"
                    v-if="formPayload.items[index].product_uuid && formPayload.items[index].product_uuid.standard_price">
                    Total: {{
                      formPayload.items[index].product_uuid.standard_price *
                      formPayload.items[index].qty | formatAmount
                    }}
                  </p>
                </b-col>

                <!-- Remove Button -->
                <b-col class="mt-50" lg="2">
                  <b-button class="d-flex" v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger"
                    @click="removeItem(index)">
                    <feather-icon icon="XIcon" class="mr-25 w-100" />
                    <span>Hapus</span>
                  </b-button>
                </b-col>
                <b-col cols="12">
                  <hr>
                </b-col>
              </b-row>

            </b-form>
            <span v-if="summaryItems > 0" class="h4">Total Bundle: {{ summaryItems | formatAmount }}</span>

            <!-- Tampilkan Daftar Konten Bundle -->
            <div class="mt-2 d-flex align-items-center" style="gap: 12px;">
              <label class="mb-0 fw-bold-600 text-dark" style="font-size:14px;">
                Tampilkan Daftar Konten Bundle Pada Struk Penjualan<span class="text-danger">*</span>
              </label>
              <b-form-radio-group
                v-model="formPayload.show_detail_on_invoice"
                :options="showBundleOptions"
                name="show-bundle-detail"
                class="bundle-radio-group"
              />
            </div>

            <!-- Riwayat Perubahan Bundle (Hanya saat Edit) -->
            <b-col cols="12" v-if="editUuid" class="mt-3">
              <hr />
              <h4 class="mb-2">Riwayat Perubahan Bundle</h4>
                  <app-timeline class="mb-2">
                <h6 class="text-muted size13" v-if="!histories.length && !isHistoryLoading">
                  History belum ada
                </h6>

                <app-timeline-item v-for="(history, index) in histories" :key="index" :title="history.title"
                  variant="primary">
                  <!-- Always show time and operator -->
                  <div class="timeline-meta mb-50">
                    <div class="size12 text-muted">
                      {{ history.time }}
                    </div>

                    <div v-if="history.operator_name" class="size12 text-muted">
                      oleh {{ history.operator_name }}
                    </div>
                  </div>

                  <!-- Price -->
                  <div v-if="history.properties && history.properties.price && history.title != 'Tambah bundling'"
                    class="size13 text-dark font-weight-bold mt-25">
                    Harga:
                    <span>
                      {{ history.properties.price.from | formatAmount }}
                    </span>
                    &rarr;
                    <span>
                      {{ history.properties.price.to | formatAmount }}
                    </span>
                  </div>

                  <!-- Name -->
                  <div v-if="history.properties && history.properties.name && history.title != 'Tambah bundling'"
                    class="size13 text-dark font-weight-bold mt-25">
                    Nama:
                    {{ history.properties.name.from }}
                    &rarr;
                    {{ history.properties.name.to }}
                  </div>

                  <!-- is_no_period -->
                  <div v-if="history.properties && history.properties.is_no_period !== undefined && history.title != 'Tambah bundling'"
                    class="size13 text-dark font-weight-bold mt-25">
                    Masa Berlaku:
                    {{ history.properties.is_no_period.from ? 'Tanpa Periode' : 'Periode Waktu' }}
                    &rarr;
                    {{ history.properties.is_no_period.to ? 'Tanpa Periode' : 'Periode Waktu' }}
                  </div>

                  <!-- start_date -->
                  <div v-if="history.properties && history.properties.start_date && history.title != 'Tambah bundling'"
                    class="size13 text-dark font-weight-bold mt-25">
                    Berlaku Dari:
                    {{ history.properties.start_date.from || '-' }}
                    &rarr;
                    {{ history.properties.start_date.to || '-' }}
                  </div>

                  <!-- end_date -->
                  <div v-if="history.properties && history.properties.end_date && history.title != 'Tambah bundling'"
                    class="size13 text-dark font-weight-bold mt-25">
                    Berlaku Sampai:
                    {{ history.properties.end_date.from || '-' }}
                    &rarr;
                    {{ history.properties.end_date.to || '-' }}
                  </div>

                  <!-- show_detail_on_invoice -->
                  <div v-if="history.properties && history.properties.show_detail_on_invoice !== undefined && history.title != 'Tambah bundling'"
                    class="size13 text-dark font-weight-bold mt-25">
                    Tampilkan Detail di Struk:
                    {{ history.properties.show_detail_on_invoice.from ? 'Ya' : 'Tidak' }}
                    &rarr;
                    {{ history.properties.show_detail_on_invoice.to ? 'Ya' : 'Tidak' }}
                  </div>

                  <div v-if="history.title === 'Tambah bundling'">
                    Bundle Ditambahkan
                  </div>

                  <!-- Product changes -->
                  <div v-if="history.properties && history.properties.product_changes" class="mt-25">
                    <!-- Added -->
                    <div v-if="
                      history.properties.product_changes.added &&
                      history.properties.product_changes.added.length
                    " class="text-success size12 font-weight-bold">
                      + Ditambahkan:

                      <div v-for="(p, pIdx) in history.properties.product_changes.added" :key="'add-' + pIdx"
                        class="ml-1 text-dark">
                        • {{ p.name }} ({{ p.qty }} Pcs)
                      </div>
                    </div>

                    <!-- Removed -->
                    <div v-if="
                      history.properties.product_changes.removed &&
                      history.properties.product_changes.removed.length
                    " class="text-danger size12 font-weight-bold mt-25">
                      - Dihapus:

                      <div v-for="(p, pIdx) in history.properties.product_changes.removed" :key="'rem-' + pIdx"
                        class="ml-1 text-dark">
                        • {{ p.name }} ({{ p.qty }} Pcs)
                      </div>
                    </div>

                    <!-- Changed -->
                    <div v-if="
                      history.properties.product_changes.changed &&
                      history.properties.product_changes.changed.length
                    " class="text-warning size12 font-weight-bold mt-25">
                      ~ Jumlah Diubah:

                      <div v-for="(p, pIdx) in history.properties.product_changes.changed" :key="'chg-' + pIdx"
                        class="ml-1 text-dark">
                        • {{ p.name }}:
                        {{ p.from_qty }} Pcs
                        &rarr;
                        {{ p.to_qty }} Pcs
                      </div>
                    </div>
                  </div>

                  <!-- Generic product update -->
                  <div v-else-if="history.properties && history.properties.products"
                    class="size13 text-dark font-weight-bold mt-25">
                    Daftar produk bundling diperbarui
                  </div>
                </app-timeline-item>
              </app-timeline>
              <a
                v-if="historyNextPageUrl"
                class="text-primary size13 font-weight-bold"
                style="cursor: pointer;"
                :disabled="isHistoryLoading"
                @click="loadMoreHistories"
              >
                <b-spinner small v-if="isHistoryLoading" /> Lihat Selengkapnya
              </a>
            </b-col>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <template #modal-footer="{}">
      <div v-if="isLoading">
        <br>
        <b-spinner class="mb-2" variant="primary" /><br>
      </div>
      <b-button variant="primary" @click="editUuid ? updateItem() : createItem()">
        Simpan Bundle
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import _ from 'lodash'
/* eslint-disable vue/require-default-prop */
import {
  BModal, BContainer, BRow, BCol, BButton, BFormGroup, BFormInput, BFormTextarea, BCard, BFormFile, BFormDatepicker, BFormSpinbutton, BFormSelect, BFormSelectOption, BForm, BSpinner, BFormCheckbox, BFormRadioGroup,
} from 'bootstrap-vue'

import { formatRupiah } from '@/auth/utils'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import vSelect from "vue-select";
import { destroyed } from 'vue-echarts'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BContainer,
    BCard,
    BFormFile,
    BFormDatepicker,
    BFormSpinbutton,
    BFormSelect,
    BFormSelectOption,
    BForm,
    vSelect,
    BSpinner,
    BFormCheckbox,
    BFormRadioGroup,
    AppTimeline,
    AppTimelineItem,
  },
  directives: {
    Ripple,
  },
  props: {
    formData: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: '',
    },
    createItem: {
      type: Function,
    },
    editItem: {
      type: Function,
    },
    editId: {
      type: String,
    },
    updateItem: {
      type: Function,
    },
    cleanUpForm: {
      type: Function,
    },
    iconBank: {
      type: String,
    },
    isLoading: {
      type: Boolean
    }
  },
  mixins: [heightTransition],
  setup() {
    return {
      formatRupiah
    }
  },
  watch: {
    iconBank(value) {
      this.photo_url = value
    },
    editId(value) {
      this.editUuid = value
      if (value) {
        this.historyPage = 1
        this.histories = []
        this.fetchHistories()
      }
    },
    formData(value) {
      this.price = value.price
      this.formPayload = value

      for (let index = 0; index < value.items.length; index++) {
        this.optionsWarehouse.push({
          warehouses: [],
        })
      }
    },
    formPayload: {
      handler(value) {
        this.$emit('getPayload', value)
      },
      deep: true,
    },
    'formPayload.items': {
      handler(value, oldValue) {
        if (value.length) {
          for (let index = 0; index < value.length; index++) {
            const element = value[index];
            this.checkStock(index, element.product_uuid, element.warehouse_uuid)
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    summaryItems() {
      const total = this.formPayload.items.map(item => {
        const price = item && item.product_uuid && item.product_uuid.standard_price ? item.product_uuid.standard_price : 0;
        const qty = item && item.qty ? item.qty : 0;

        return price * qty;
      });
      const sum = total.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

      return sum;
    }
  },
  data() {
    return {
      formPayload: {
        items: [],
        show_detail_on_invoice: true,
      },
      showBundleOptions: [
        { text: 'Iya', value: true },
        { text: 'Tidak', value: false },
      ],
      photo_url: '',
      editUuid: null,
      items: [],
      nextTodoId: 2,
      optionsWarehouse: [
        {
          warehouses: []
        }
      ],
      optionsProduct: [],
      price: '',
      histories: [],
      historyPage: 1,
      historyNextPageUrl: null,
      isHistoryLoading: false,
    }
  },
  mounted() {
    // this.initTrHeight()
    // this.getWarehouse()
    this.getItems()
  },
  created() {
    // window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    // window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    increaseQty(index) {
      this.formPayload.items[index].qty++;
    },
    decreaseQty(index) {
      if (this.formPayload.items[index].qty > 1) {
        this.formPayload.items[index].qty--;
      }
    },
    validateQty(index) {
      let val = this.formPayload.items[index].qty;
      if (val === null || val === '' || isNaN(val)) {
        this.formPayload.items[index].qty = 0;
      }
    },
    updateQty(index, value) {
      const numeric = parseFloat(value);
      if (!isNaN(numeric) && numeric >= 0) {
        this.formPayload.items[index].qty = numeric;
      }
    },
    handleHideModal(event) {
      this.items = []
      this.editUuid = null
      this.histories = []
      this.historyPage = 1
      this.historyNextPageUrl = null
      this.isHistoryLoading = false
      this.formPayload = {
        items: [],
        show_detail_on_invoice: true,
      }
      this.$emit('getPayload', this.formPayload)
    },
    async fetchHistories() {
      if (!this.editUuid) return
      this.isHistoryLoading = true
      try {
        const response = await this.$http.get(`/product-bundles/${this.editUuid}/histories`, {
          params: { per_page: 5, page: this.historyPage }
        })
        const data = response.data?.data?.data || []
        if (this.historyPage === 1) {
          this.histories = data
        } else {
          this.histories.push(...data)
        }
        this.historyNextPageUrl = response.data?.data?.next_page_url || null
      } catch (err) {
        console.log(err)
      } finally {
        this.isHistoryLoading = false
      }
    },
    loadMoreHistories() {
      if (this.historyNextPageUrl && !this.isHistoryLoading) {
        this.historyPage++
        this.fetchHistories()
      }
    },
    checkStock(index, product_uuid, warehouse_uuid) {
      if (product_uuid) {
        this.$http.get(`/warehouse?product_uuid_ignore_stock=${product_uuid?.uuid || product_uuid}`)
          .then((result) => {
            if (result.data.data?.length) {
              this.optionsWarehouse[index].warehouses = result.data.data.map((e) => {
                return {
                  name: e.name,
                  uuid: e.uuid,
                };
              });
            } else {
              this.optionsWarehouse[index].warehouses = []
              this.formPayload.items[index].warehouse_uuid = null
            }
          }).catch((err) => {
            console.log(err);
          });
      } else {
        this.formPayload.items[index].warehouse_uuid = null
      }
    },
    onSearchProduct(search, loading) {
      if (search.length) {
        loading(true)
        this.searchProduct(loading, search, this)
      }
    },
    searchProduct: _.debounce((loading, search, vm) => {
      vm.$store.dispatch("cashier/getData", {
        uuid: '',
        params: {
          search,
        },
      })
        .then((response) => {
          vm.optionsProduct = response.data.data.data.map((e) => {
            return {
              name: e.alias_name,
              uuid: e.uuid,
              standard_price: e.standard_price
            };
          });
          loading(false);
        })
        .catch((error) => {
          loading(false);
        });
      loading(false)
    }, 300),
    async getItems() {
      try {
        const result = await this.$store.dispatch('cashier/getData', {
          uuid: '',
          params: {
            per_page: 10,
          },
        });

        this.optionsProduct = result.data.data.data.map(element => ({
          name: element.alias_name,
          uuid: element.uuid,
          standard_price: element.standard_price
        }));

      } catch (err) {
        console.log(err);
      }
    },
    onSearchWarehouse(search, loading) {
      if (search.length) {
        loading(true)
        this.searchWarehouse(loading, search, this)
      }
    },
    searchWarehouse: _.debounce((loading, search, vm) => {
      vm.$store.dispatch("warehouse/getData", {
        uuid: '',
        params: {
          search,
        },
      })
        .then((response) => {
          vm.optionsWarehouse = response.data.data.data.map((e) => {
            return {
              name: e.name,
              uuid: e.uuid,
            };
          });
          loading(false);
        })
        .catch((error) => {
          loading(false);
        });
      loading(false)
    }, 300),
    getWarehouse() {
      this.$store
        .dispatch("warehouse/getData", {
          uuid: "",
          params: "",
        })
        .then((result) => {
          const warehouses = result.data.data
          for (let index = 0; index < warehouses.length; index++) {
            const element = warehouses[index]
            this.optionsWarehouse.push({
              name: element.name,
              uuid: element.uuid,
            })
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    repeateAgain() {
      this.formPayload.items.push({
        qty: 0,
        warehouse_uuid: null,
        product_uuid: null
      })
      this.items.push({
        stock: null,
      })
      this.optionsWarehouse.push({
        warehouses: [],
      })
      // this.$nextTick(() => {
      //   this.trAddHeight(this.$refs.row[0].offsetHeight)
      // })
    },
    removeItem(index) {
      this.formPayload.items.splice(index, 1)
      this.items.splice(index, 1)
      // this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    // initTrHeight() {
    //   this.trSetHeight(null)
    //   this.$nextTick(() => {
    //     this.trSetHeight(this.$refs.form.scrollHeight)
    //   })
    // },
    getPhoto(value) {
      this.formPayload.image = value.photo
    },
    directPage() {
      this.cleanUpForm()
      this.$bvModal.hide('modal-item')
    },
    getPrice() {
      const rupiah = document.getElementById('v-total-price');
      if (rupiah?.value) {
        rupiah.value = this.formatRupiah(rupiah.value, "");
        this.formPayload.price = parseFloat(rupiah.value.replaceAll('.', ''))
      }
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.spinner__button {
  display: flex;
  align-items: center;
  border-radius: 8px;
  // overflow: hidden;
  border: 1px solid #ccc;
  background-color: #f8f9fa;
  padding: 2px 4px;
  height: 52px; /* Uniform height */
}

.value-button {
  height: 75%;
  cursor: pointer;
  user-select: none;
}

.qty:focus {
  outline: none;
  box-shadow: none;
}


// #modal-bundle {
//   .vs__dropdown-menu {
//     max-width: unset;
//     width: max-content;
//   }
// }</style>
<style lang="scss" scoped>
.box__upload--photo {

  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #EFF1F5;
  border: 1px dashed #7A7F94;
  border-radius: 8px;
  position: relative;

  background-repeat: no-repeat;
  background-size: cover;
  object-fit: cover;

  width: 140px;
  height: 140px;

  .floating__close--button {
    position: absolute;
    top: 6px;
    width: 24px;
    height: 24px;
    right: 6px;
    background: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>

<style lang="scss">
@import '@/assets/scss/variables/_variables.scss';

@media (min-width: 1200px) {
  .bundle-modal {
    .modal-dialog {
      max-width: 70% !important;
    }
  }
}

.repeater-form {
  .v-select .vs__selected {
    max-width: calc(100% - 40px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .v-select .vs__selected-options {
    overflow: hidden;
  }

  .v-select .vs__dropdown-toggle {
    min-height: 38px;
  }
}

.bundle-radio-group {
  .custom-control {
    margin-right: 16px;
  }
  .custom-control-label {
    font-size: 14px;
    font-weight: 600;
    color: #2c948a;
    cursor: pointer;
    padding-left: 4px;

    &::before {
      border-color: #2c948a;
    }
  }
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #2c948a;
    border-color: #2c948a;
  }
}
</style>
